/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { Box, Typography } from '@material-ui/core';

import config from '../../../../../../../../config';
import { useGetAddressByCep } from '../../../../../../../../shared/hooks/useGetAddressByCep';
import {
  FormInputsContainer,
  CustomTextField,
  CustomForm,
  CustomFormError,
} from '../../../../styles';
import useConfigsStore from '../../../../../../store/configsStore';
import usePageStore from '../../../../../../store/pageStore';

export default function BeginDevolutionForm({
  queryParametersData,
  showAddressFields,
  onFormSubmit,
  hideOrderNumberField,
  hideEmailField,
  disableUrlCompletedFields,
}) {
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const storeId = useConfigsStore((state) => state.storeId);
  const storeConfigs = useConfigsStore((state) => state.storeConfigs);
  const showClientCreationForm = usePageStore(
    (state) => state.showClientCreationForm,
  );
  const memphisOrderInfo = usePageStore((state) => state.memphisOrderInfo);
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    control,
  } = useForm();
  const { getAddressByCep, data: cepData } = useGetAddressByCep();

  // This is responsible to set the query parameters data to the form, if it exists
  useEffect(() => {
    if (
      storeConfigs?.enableMemphisOrderInfoSearch &&
      memphisOrderInfo &&
      !cepData
    ) {
      const { eTicket, clientEmail, clientPhone, clientName } =
        memphisOrderInfo;
      if (eTicket) {
        setValue('orderNumber', eTicket);
      }
      if (clientEmail) {
        setValue('email', clientEmail);
      }
      if (clientPhone) {
        setValue('phone', clientPhone);
      }
      if (clientName) {
        setValue('name', clientName);
      }
    } else if (queryParametersData) {
      const { orderNumber, clientEmail, clientPhone, clientName } =
        queryParametersData;
      if (orderNumber) {
        setValue('orderNumber', orderNumber);
      }
      if (clientEmail) {
        setValue('email', clientEmail);
      }
      if (clientPhone) {
        setValue('phone', clientPhone);
      }
      if (clientName) {
        setValue('name', clientName);
      }
    }
  }, [queryParametersData, memphisOrderInfo]);

  useEffect(() => {
    if (cepData) {
      setValue('street', cepData.logradouro);
      setValue('neighborhood', cepData.bairro);
      setValue('city', cepData.localidade);
      setValue('state', cepData.uf);
      setValue('complement', cepData.complemento);
    }
  }, [cepData]);

  const fontColor = devolutionPageConfigs?.fontColor || '#000000';
  const fontFamily =
    devolutionPageConfigs?.fontFamily || 'helvetica, sans-serif';

  /**
   * Dear future developer...
   *
   * Unfortunatelly, Oi store has a different requirement for the input form...
   * not a good practice keep this hardcoded but this requirement came after
   * the project and it's structure was already done...
   *
   * Maybe the best approach would be to create a hole new flow to handle this
   * different requirement... But for now we will keep this way...
   */
  const getOiStoreId = () => {
    // The dev and staging ids does not corresponto to Oi Store, they are used only for testing
    // can change in the future depending on which store is being used
    switch (config.env) {
      case 'dev':
        return 'c8640496-98c3-411f-8385-8520d8b8119d';
      case 'staging':
        return '11fab34a-3faf-4177-a6dd-73a9e67c5e67';
      case 'prod':
        return '9a13242b-f551-400b-aa54-7a993be7e9bb';
      default:
        return '9a13242b-f551-400b-aa54-7a993be7e9bb';
    }
  };
  const isOiStore = storeId === getOiStoreId();

  return (
    <CustomForm id="order-creation" onSubmit={handleSubmit(onFormSubmit)}>
      <FormInputsContainer>
        {!hideOrderNumberField && (
          <>
            <Controller
              name="orderNumber"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CustomTextField
                  {...field}
                  bordercolor={fontColor}
                  fullWidth
                  label="Número do pedido"
                  variant="outlined"
                  inputProps={{
                    style: { fontFamily },
                  }}
                  InputLabelProps={{
                    shrink: field.value,
                    style: { fontFamily },
                  }}
                  disabled={disableUrlCompletedFields}
                />
              )}
            />
            {errors &&
              errors.orderNumber &&
              errors.orderNumber.type === 'required' && (
                <CustomFormError>
                  Número do pedido é obrigatório
                </CustomFormError>
              )}
            <Box sx={{ padding: '5px 0' }} />
          </>
        )}
        {!hideEmailField && (
          <>
            <Controller
              name="email"
              control={control}
              rules={{
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'invalid_email',
                },
              }}
              render={({ field }) => (
                <CustomTextField
                  {...field}
                  bordercolor={fontColor}
                  fullWidth
                  label={isOiStore ? 'E-mail do cliente *' : 'E-mail *'}
                  variant="outlined"
                  inputProps={{
                    style: { fontFamily },
                  }}
                  InputLabelProps={{
                    shrink: field.value,
                    style: { fontFamily },
                  }}
                />
              )}
            />
            {errors && errors.email && errors.email.type === 'required' && (
              <CustomFormError>Email é obrigatório</CustomFormError>
            )}
            {errors &&
              errors.email &&
              errors.email.type === 'pattern' &&
              errors.email.message === 'invalid_email' && (
                <CustomFormError>Email inválido</CustomFormError>
              )}
          </>
        )}
        {isOiStore && (
          <>
            <Box sx={{ padding: '5px 0' }} />
            <Controller
              name="oiEmployeeName"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CustomTextField
                  {...field}
                  bordercolor={fontColor}
                  fullWidth
                  label="Nome do funcionário *"
                  variant="outlined"
                  inputProps={{
                    style: { fontFamily },
                  }}
                  InputLabelProps={{
                    shrink: field.value,
                    style: { fontFamily },
                  }}
                  disabled={disableUrlCompletedFields}
                />
              )}
            />
            {errors &&
              errors.oiEmployeeName &&
              errors.oiEmployeeName.type === 'required' && (
                <CustomFormError>
                  Nome do funcionário é obrigatório
                </CustomFormError>
              )}
            <Box sx={{ padding: '5px 0' }} />
            <Controller
              name="oiEmployeeRegistrationNumber"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CustomTextField
                  {...field}
                  bordercolor={fontColor}
                  fullWidth
                  label="Número de matrícula *"
                  variant="outlined"
                  inputProps={{
                    style: { fontFamily },
                  }}
                  InputLabelProps={{
                    shrink: field.value,
                    style: { fontFamily },
                  }}
                  disabled={disableUrlCompletedFields}
                />
              )}
            />
            {errors &&
              errors.oiEmployeeRegistrationNumber &&
              errors.oiEmployeeRegistrationNumber.type === 'required' && (
                <CustomFormError>
                  Número de matrícula é obrigatório
                </CustomFormError>
              )}
            <Box sx={{ padding: '5px 0' }} />
          </>
        )}
        {showClientCreationForm && (
          <>
            <Box sx={{ padding: '5px 0' }} />
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              shouldUnregister={!showClientCreationForm}
              render={({ field }) => (
                <CustomTextField
                  {...field}
                  bordercolor={fontColor}
                  fullWidth
                  label="Nome *"
                  variant="outlined"
                  inputProps={{
                    style: { fontFamily },
                  }}
                  InputLabelProps={{
                    shrink: field.value,
                    style: { fontFamily },
                  }}
                />
              )}
            />
            {errors && errors.name && errors.name.type === 'required' && (
              <CustomFormError>Nome é obrigatório</CustomFormError>
            )}
            <Box sx={{ padding: '5px 0' }} />
            <Controller
              name="phone"
              control={control}
              rules={{ required: true, minLength: 10 }}
              shouldUnregister={!showClientCreationForm}
              render={({ field: { onChange, value } }) => (
                <InputMask
                  mask="99 99999-9999"
                  maskChar={null}
                  value={value}
                  onChange={(e) => {
                    const cleannedValue = e.target.value
                      .replace(/-/g, '')
                      .replace(' ', '')
                      .replace(/_/g, '');
                    onChange({ ...e, target: { value: cleannedValue } });
                  }}
                >
                  {(inputProps) => (
                    <CustomTextField
                      {...inputProps}
                      bordercolor={fontColor}
                      fullWidth
                      label="Telefone *"
                      variant="outlined"
                      inputProps={{
                        style: { fontFamily },
                      }}
                      InputLabelProps={{
                        shrink: inputProps.value,
                        style: { fontFamily },
                      }}
                    />
                  )}
                </InputMask>
              )}
            />
            {errors && errors.phone && errors.phone.type === 'required' && (
              <CustomFormError>Telefone é obrigatório</CustomFormError>
            )}
            {errors && errors.phone && errors.phone.type === 'minLength' && (
              <CustomFormError>Telefone inválido</CustomFormError>
            )}
            {showAddressFields && (
              <>
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="cpf"
                  control={control}
                  rules={{ required: true, minLength: 11 }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field: { onChange, value } }) => (
                    <InputMask
                      mask="999.999.999-99"
                      maskChar={null}
                      value={value}
                      onChange={(e) => {
                        const cleannedValue = e.target.value
                          .replace(/-/g, '')
                          .replace(/\./g, '')
                          .replace(/_/g, '');
                        onChange({ ...e, target: { value: cleannedValue } });
                      }}
                    >
                      {(inputProps) => (
                        <CustomTextField
                          {...inputProps}
                          bordercolor={fontColor}
                          fullWidth
                          label="CPF *"
                          variant="outlined"
                          inputProps={{
                            style: { fontFamily },
                          }}
                          InputLabelProps={{
                            shrink: inputProps.value,
                            style: { fontFamily },
                          }}
                        />
                      )}
                    </InputMask>
                  )}
                />
                {errors && errors.cpf && errors.cpf.type === 'required' && (
                  <CustomFormError>CPF é obrigatório</CustomFormError>
                )}
                {errors && errors.cpf && errors.cpf.type === 'minLength' && (
                  <CustomFormError>CPF inválido</CustomFormError>
                )}

                <Typography style={{ marginTop: '20px' }}>Endereço</Typography>
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="cep"
                  control={control}
                  rules={{ required: true, minLength: 8 }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field: { onChange, value } }) => (
                    <InputMask
                      mask="99999-999"
                      maskChar={null}
                      value={value}
                      onBlur={async () => {
                        if (value && value.length === 8) {
                          await getAddressByCep(value);
                        }
                      }}
                      onChange={(e) => {
                        const cleannedValue = e.target.value
                          .replace(/-/g, '')
                          .replace(/_/g, '');
                        onChange({ ...e, target: { value: cleannedValue } });
                      }}
                    >
                      {(inputProps) => (
                        <CustomTextField
                          {...inputProps}
                          bordercolor={fontColor}
                          fullWidth
                          label="CEP *"
                          variant="outlined"
                          inputProps={{
                            style: { fontFamily },
                          }}
                          InputLabelProps={{
                            shrink: inputProps.value,
                            style: { fontFamily },
                          }}
                        />
                      )}
                    </InputMask>
                  )}
                />
                {errors && errors.cep && errors.cep.type === 'required' && (
                  <CustomFormError>CEP é obrigatório</CustomFormError>
                )}
                {errors && errors.cep && errors.cep.type === 'minLength' && (
                  <CustomFormError>CEP inválido</CustomFormError>
                )}
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="street"
                  control={control}
                  rules={{ required: true }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field }) => (
                    <CustomTextField
                      {...field}
                      bordercolor={fontColor}
                      fullWidth
                      label="Rua *"
                      variant="outlined"
                      inputProps={{
                        style: { fontFamily },
                      }}
                      InputLabelProps={{
                        shrink: field.value,
                        style: { fontFamily },
                      }}
                    />
                  )}
                />
                {errors &&
                  errors.street &&
                  errors.street.type === 'required' && (
                    <CustomFormError>Rua é obrigatório</CustomFormError>
                  )}
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="number"
                  control={control}
                  rules={{ required: true }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field }) => (
                    <CustomTextField
                      {...field}
                      bordercolor={fontColor}
                      fullWidth
                      label="Número *"
                      variant="outlined"
                      inputProps={{
                        style: { fontFamily },
                      }}
                      InputLabelProps={{
                        shrink: field.value,
                        style: { fontFamily },
                      }}
                    />
                  )}
                />
                {errors &&
                  errors.number &&
                  errors.number.type === 'required' && (
                    <CustomFormError>Número é obrigatório</CustomFormError>
                  )}
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="neighborhood"
                  control={control}
                  rules={{ required: true }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field }) => (
                    <CustomTextField
                      {...field}
                      bordercolor={fontColor}
                      fullWidth
                      label="Bairo *"
                      variant="outlined"
                      inputProps={{
                        style: { fontFamily },
                      }}
                      InputLabelProps={{
                        shrink: field.value,
                        style: { fontFamily },
                      }}
                    />
                  )}
                />
                {errors &&
                  errors.neighborhood &&
                  errors.neighborhood.type === 'required' && (
                    <CustomFormError>Bairo é obrigatório</CustomFormError>
                  )}
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="city"
                  control={control}
                  rules={{ required: true }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field }) => (
                    <CustomTextField
                      {...field}
                      bordercolor={fontColor}
                      fullWidth
                      label="Cidade *"
                      variant="outlined"
                      inputProps={{
                        style: { fontFamily },
                      }}
                      InputLabelProps={{
                        shrink: field.value,
                        style: { fontFamily },
                      }}
                    />
                  )}
                />
                {errors && errors.city && errors.city.type === 'required' && (
                  <CustomFormError>Cidade é obrigatório</CustomFormError>
                )}
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="state"
                  control={control}
                  rules={{ required: true }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field }) => (
                    <CustomTextField
                      {...field}
                      bordercolor={fontColor}
                      fullWidth
                      label="Estado *"
                      variant="outlined"
                      inputProps={{
                        style: { fontFamily },
                      }}
                      InputLabelProps={{
                        shrink: field.value,
                        style: { fontFamily },
                      }}
                    />
                  )}
                />
                {errors && errors.state && errors.state.type === 'required' && (
                  <CustomFormError>Estado é obrigatório</CustomFormError>
                )}
                <Box sx={{ padding: '5px 0' }} />
                <Controller
                  name="complement"
                  control={control}
                  rules={{ required: false }}
                  shouldUnregister={
                    !showClientCreationForm || !showAddressFields
                  }
                  render={({ field }) => (
                    <CustomTextField
                      {...field}
                      bordercolor={fontColor}
                      fullWidth
                      label="Complemento"
                      variant="outlined"
                      inputProps={{
                        style: { fontFamily },
                      }}
                      InputLabelProps={{
                        shrink: field.value,
                        style: { fontFamily },
                      }}
                    />
                  )}
                />
                {errors &&
                  errors.complement &&
                  errors.complement.type === 'required' && (
                    <CustomFormError>Complemento é obrigatório</CustomFormError>
                  )}
              </>
            )}
          </>
        )}
      </FormInputsContainer>
    </CustomForm>
  );
}
